<template>
  <div class="container">
    <div class="content_top">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>社会服务</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main_wrapper">
      <div class="content_left">
        <left-bar
          title="社会服务"
          :sub-title-list="subtitleList"
          pre-selected="全部"
          @handleSelect="handleSelect"
        ></left-bar>
      </div>
      <div class="content_right">
        <ul>
          <li v-for="(item, i) in newsList" :key="i" class="news_item" @click="gotoDeatil(item.id)" style="cursor:pointer">
            <div class="news_left">
              <img
                class="news_pic"
                :src="item.cover"
                :alt="item.title"
              />
            </div>
            <div class="news_right">
              <p class="news_title">
                <a :href="item.url">{{ item.title }}</a>
              </p>
              <p class="news_date">{{ item.createTime }}</p>
            </div>
          </li>
        </ul>
        <!-- 分页 -->
        <div class="pagination">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="5"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background>
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftBar from "@/components/LeftBar.vue";
import { socoalServiceTypeFilter } from "@/util/filter";
import requests from "@/api/request";

export default {
  name: "SocialServiceListView",
  components: { LeftBar },
  filters: { socoalServiceTypeFilter },
  data() {
    return {
      subtitleList: ["全部","社区服务","党团建设"],
      newsList: [],
      currentPage: 1,
      total:0,
      pageSize:5,
      newsList: [],
      isFirst:1
    };
  },
  mounted(){
    this.getNewsList(this.currentPage,this.pageSize);
    this.isFirst=0;
  },
  methods: {
    socoalServiceTypeFilter,
    // 切换类型
    async handleSelect(title) {
      this.page=1;
      if(title==='社区服务'){
        var category=0;
      } else if(title==='党团建设'){
        var category=1;
      } else {
        if(this.isFirst==0){
          this.getNewsList(this.page, this.pageSize);
        }
        return;
      }
      return requests({
        url: "/social/showSocialPages?page=" + this.currentPage + "&pageSize=" + this.pageSize+"&category="+category,
        method: "GET",
      }).then(res => {
        // console.log('handleSelect', res.data);
        this.newsList.splice(0,this.newsList.length);
        this.total=res.data.counts;
        let d = res.data.items;
        d.forEach((item,i) => {
          this.newsList.push(d[i]);
          // this.$set(this.newsList[i], 'date', d[i].createTime.substring(0,10));
        });
        // console.log('this.NewsList',this.NewsList);
      }).catch(err => {
        console.log('error', err)
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error'
        });
      });
    },
    // 分页获取数据
    async getNewsList(page, pageSize) {
      return requests({
        url: "/social/showSocialPages?page=" + page + "&pageSize=" + pageSize,
        method: "GET"
      }).then(res => {
        console.log('getNewsListres', res);
        this.newsList.splice(0,this.newsList.length);
        this.total=res.data.counts;
        let d = res.data.items;
        d.forEach((item,i) => {
          this.newsList.push(d[i]);
        });
        // console.log('this.NewsList',this.NewsList);
      }).catch(err => {
        console.log('error', err)
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error'
        });
      });
    },
    // 调整每页显示条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize=val;
      this.getNewsList(this.currentPage,this.pageSize);
    },
    // 调整页数
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage=val;
      this.getNewsList(this.currentPage,this.pageSize);
    },
    // 详情
    gotoDeatil(id){
      this.$router.push({name:'social_services_detail',query: {id:id}})
    }
  }
};
</script>
<style scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}

.content_top {
  margin: 20px 0;
}

.main_wrapper {
  display: flex;
}

.content_left {
  width: 340px;
  margin-right: 60px;
}

.el-breadcrumb ::v-deep .el-breadcrumb__inner:hover {
  color: #63065f;
}

.content_right ul {
  padding: 0;
  margin: 0;
}

.content_right {
  width: 800px;
}

.news_item {
  height: 160px;
  width: 100%;
  display: flex;
  margin: 0 auto 10px;
  /*background-color: #63065f;*/
}

.news_left {
  margin-right: 20px;
}

.news_pic {
  width: 240px;
  height: 160px;
}

.news_right {
  padding: 0 10px;
  text-align: left;
}

.news_title {
  line-height: 60px;
  font-size: 20px;
}

.pagination{
  margin: 20px 0;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #63065f;
}
</style>
